import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../api/quarkusApi';

export function useIncome(incomeId) {
  const navigate = useNavigate();

  const [income, setIncome] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchIncome = useCallback(() => {
    if (!incomeId) {
      setIncome(null);
      return;
    }
    setLoading(true);
    quarkusApi
      .get(`/financial/incomes/${incomeId}`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .then((returnFromApi) => setIncome(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [incomeId, navigate]);

  useEffect(() => {
    fetchIncome();
  }, [fetchIncome]);

  return { income, isLoading, error, refetch: fetchIncome };
}
